import { useState, useEffect, useRef } from "react";

import { usePlayground } from "@/components/Playground/playground-store";

const useAutoOpen = (
  count: number,
  isCollapsed: boolean,
  setIsCollapsed: (value: boolean) => void,
  enabled = true,
) => {
  const [previousCount, setPreviousCount] = useState<number>(count);
  const playground = usePlayground();
  const wasBelowThresholdRef = useRef(false);
  const hasCollapsedForCycleRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      const containerHeight = document.body.clientHeight;
      const isBelowThreshold = containerHeight < 1000;

      if (isBelowThreshold && !wasBelowThresholdRef.current) {
        // Crossed below threshold — collapse once for this cycle
        hasCollapsedForCycleRef.current = true;
        setIsCollapsed(true);
      } else if (!isBelowThreshold && wasBelowThresholdRef.current) {
        // Crossed back above threshold — expand and reset for next cycle
        hasCollapsedForCycleRef.current = false;
        setIsCollapsed(false);
      }

      wasBelowThresholdRef.current = isBelowThreshold;
    });
    resizeObserver.observe(document.body);
    return () => {
      resizeObserver.disconnect();
    };
  }, [enabled, setIsCollapsed]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (
      (count !== undefined && previousCount !== undefined && count > previousCount) ||
      playground.isPendingNewMessage
    ) {
      setIsCollapsed(false);
    }
    setPreviousCount(count);
  }, [enabled, count, playground.isPendingNewMessage, previousCount, setIsCollapsed]);
};

export default useAutoOpen;
